// Pure helpers for rendering authority topic candidates. Extracted
// from AuthorityTopicQueue.jsx + ComposeGroundingRail.jsx + uiDashboard.jsx
// so the polymorphic-schema tolerance (sourceRecordLinks shape,
// score scale) lives in one tested place. Both helpers were
// inlined originally and drifted out of sync — the audit caught a
// "Sources: undefined:undefined" + "6800%" double-bug because each
// renderer handled the polymorphism differently (or not at all).

/**
 * `sourceRecordLinks` is polymorphic by producer:
 *   - proofAssetsService emits  { recordType, recordId, title }
 *   - topicDiscoveryService emits { type, id } for signal links
 *
 * Returns a "type:id" string, or just whichever side is present,
 * or null if neither resolves. Pure formatter; no React, no async.
 */
export function formatSourceLink(link) {
  const recordType = link?.recordType || link?.type
  const recordId = link?.recordId || link?.id
  if (!recordType && !recordId) return null
  if (recordType && recordId) return `${recordType}:${recordId}`
  return String(recordType || recordId)
}

/**
 * `score` is also polymorphic by producer:
 *   - topicDiscoveryService / topicAutoPromoter emit 0–100 integers
 *     (60 baseline, 70+ auto-promote threshold per CLAUDE.md)
 *   - proofAssetsService emits 0–1 fractions (0.86 / 0.72)
 *
 * Heuristic: anything <= 1 is treated as a fraction and scaled up;
 * anything > 1 is treated as already 0–100. Returns an integer.
 * The pre-fix renderers multiplied by 100 unconditionally, turning
 * a 68 into "6800%" — the operator-trust killer the audit flagged.
 */
export function normalizeScore(raw) {
  const n = Number(raw || 0)
  if (!Number.isFinite(n) || n <= 0) return 0
  return n <= 1 ? Math.round(n * 100) : Math.round(n)
}
